import {FilesService} from "@/services/files";
import {mapFields} from "vuex-map-fields";
import {mapMutations} from "vuex";
import {MUTATE_ADD_ATTACHED_ID, MUTATE_ADD_ATTACHED_PRESCRIPTION} from "@/store/types";
import {NUMBER_OF_DAYS_AFTER_EXPIRY} from "@/reference/app-constants";

import CloseModalMixin from "@/mixins/close-modal-mixin";
import GetElementString from "@/mixins/get-element-string";
import moment from "moment";

// import pdf from "vue-pdf";
import pdf from "@teckel/vue-pdf"; //forked package that fixed bug on vue-pdf:

import PreviewType from "@/reference/preview-file-type";
import {getCouponLogo} from '@/reference/coupon';
import Routes from "@/router/routes";
import WatsonsSmallLogo from "@/assets/images/pharmacies/img003.png";
import NSHeartLogo from "@/assets/images/ico001.svg";

export default {
  name: 'preview-file-mixin',
  mixins: [CloseModalMixin, GetElementString],
  components: {pdf},
  props: {
    file: {type: Array, default: []},
    title: {type: String, default: ''},
    type: {type: String, default: ''},
    showButton: {type: Boolean, default: true},
    showHeaderRightActions: {type: Boolean, default: true},
    filesView: {type: Boolean, default: false}
  },
  data() {
    return {
      isPreviewImage: false,
      pdfSrc: null,
      pdfLink: null,
      isLoading: false,
      numPages: undefined,
      pdfFileName: '',
      fileArrayIndex: 0,
    }
  },
  computed: {
    ...mapFields({
      attachedPrescriptions: 'attachedPrescriptions',
      attachedIds: 'attachedIds',
      idFileView: 'idFileView',
      prescriptionView: 'prescriptionView',
      prescriptionFileView: 'prescriptionFileView',
    }),
    attachingFilesEnabled() {
      return false;
    },
    coupon() {
      return this.file[this.fileArrayIndex].coupons[0];
    },
    couponClaimEnabled() {
      // return this.isPrescriptionWithCoupon && !this.expiredCoupon;
      return false;
    },
    computedClass() {
      return {'image-preview': this.isPreviewImage, 'file-preview': !this.pdfSrc && !this.isPreviewImage}
    },
    couponStartTime() {
      return this.file[this.fileArrayIndex].coupons ?
        this.file[this.fileArrayIndex].coupons.length ?
          moment(this.file[this.fileArrayIndex].coupons[0].issuedate).format('MMMM D, YYYY HH:mm:ss') :
          null :
        null;
    },
    couponExpirationDate() {
      const start = new Date(this.couponStartTime);
      const end = start.setDate(start.getDate() + NUMBER_OF_DAYS_AFTER_EXPIRY);
      return moment(end).format('MMMM D, YYYY');
    },
    expiredCoupon() {
      const startTime = this.file[this.fileArrayIndex].coupons ? this.file[this.fileArrayIndex].coupons.length ? moment(this.file[this.fileArrayIndex].coupons[0].issuedate).format('MMMM D, YYYY HH:mm:ss') : null : null;

      if (startTime) {
        const start = new Date(startTime);
        const now = new Date().getTime();

        const end = start.setDate(start.getDate() + NUMBER_OF_DAYS_AFTER_EXPIRY);
        const endDate = moment(end).format('MMMM D, YYYY HH:mm:ss');

        const passTime = new Date(endDate).getTime() - now;
        const daysLeft = Math.floor(passTime / (1000 * 60 * 60 * 24));
        return daysLeft < 0;
      }
      return true;
    },
    isPrescriptionFile() {
      const fileType = this.file[this.fileArrayIndex].type ? this.file[this.fileArrayIndex].type : typeof this.file[this.fileArrayIndex];
      return fileType !== 'object' && fileType !== 'string';
    },
    isPrescription() {
      return this.file[this.fileArrayIndex].pagetype === 'prescription' || this.file[this.fileArrayIndex].pagetype === 'image';
    },
    isCustomForm() {
      return this.file[this.fileArrayIndex].pagetype === 'customform';
    },
    isPrescriptionWithCoupon() {
      return !this.isPrescriptionFile && this.file[this.fileArrayIndex].coupons ? !!(this.file[this.fileArrayIndex].coupons.length) : false;
    },
    isPrescriptionWithCouponExpired() {
      return !this.isPrescriptionFile && this.expiredCoupon;
    },
    viewComponentMode() {
      return !this.$isMobile || this.$route.name === Routes.PHARMACY_ORDERS_ADD_PRESCRIPTION
    },
    previewFileTitle() {
      return this.file.length >= 1 && this.title === '' ?
             `${this.fileArrayIndex + 1}/${this.file.length} Attached ${this.file.length === 1 ? 'File' : 'Files'}`
              : this.title;
    },
    couponImage() {
      return getCouponLogo(this.coupon);
    },
  },
  methods: {
    ...mapMutations({
      addAttachedId: MUTATE_ADD_ATTACHED_ID,
      addPrescription: MUTATE_ADD_ATTACHED_PRESCRIPTION
    }),
    async fetchFileURL(token, uploadid) {
      try {
        const {data} = await FilesService.getFileURL(token, uploadid);
        if (!data) {
          throw Error();
        }
        return data.url
      } catch (e) {
        console.log(e)
      }
    },
    addPrescriptionWithCoupon() {
      this.addPrescription({...this.file[this.fileArrayIndex], partial: false, remarks: ''})
      this.$router.push({
        name: Routes.PHARMACY_ORDERS,
      })
    },
    attachFile() {
      this.attachFileWithCondition();
      this.$router.push({name: Routes.PHARMACY_ORDERS});
    },
    attachFileWithCondition() {
      if (this.type === PreviewType.PREVIEW_TYPE_PRESCRIPTION_FILE) {
        this.addPrescription({file: this.file[this.fileArrayIndex], partial: false, remarks: ''});
      } else if (this.type === PreviewType.PREVIEW_TYPE_PRESCRIPTION) {
        this.addPrescription({...this.file[this.fileArrayIndex], partial: false, remarks: ''})
      } else {
        this.addAttachedId(this.file[this.fileArrayIndex]);
      }

      this.prescriptionFileView = '';
    },
    filesAttachFile() {
      this.addPrescription({...this.file[this.fileArrayIndex], partial: false, remarks: ''})
      this.$router.push({
        name: Routes.PHARMACY_ORDERS
      })
    },
    goBack() {
      this.$goBack();
    },
    modalAttachFile() {
      this.attachFileWithCondition();
      this.closeModal({success: true});
    },
    modalGoBack() {
      this.closeModal();
    },
    previewFirstFile() {
      this.previewFile('imagePreview', this.file[this.fileArrayIndex]);
    },
    prevFileArray() {
      if (this.fileArrayIndex === 0) return;

      this.previewFile('imagePreview', this.file[this.fileArrayIndex - 1]);
      this.fileArrayIndex--;
    },
    nextFileArray() {
      if (this.fileArrayIndex === this.file.length - 1) return;

      this.previewFile('imagePreview', this.file[this.fileArrayIndex + 1]);
      this.fileArrayIndex++;
    },
    previewFile(imageRef, file) {
      const fileType = file.type ? file.type : typeof file;
      const fileImagePreviewCondition = fileType === 'image/jpeg' || fileType === 'image/png'
      const imagePreviewPane = this.$refs[imageRef];
      const reader = new FileReader();


      if (fileImagePreviewCondition) {
        this.isPreviewImage = true;
      }

      if (fileType === 'object') {
        this.isLoading = true;
        const isUploadIdAnImage = file.uploadid.includes('.jpg') || file.uploadid.includes('.png');
        if (isUploadIdAnImage) this.isLoading = false;
        this.fetchFileURL(file.token, file.uploadid).then(dataUrl => {
          if (isUploadIdAnImage) {
            imagePreviewPane.src = dataUrl;
            this.isPreviewImage = true;
          } else {
            this.pdfLink = dataUrl;
            this.pdfSrc = pdf.createLoadingTask(dataUrl);
            this.pdfSrc.promise.then(pdf => {
              this.numPages = pdf.numPages;
              this.isLoading = false;
            });
          }
        })
      } else if (fileType === 'string') {
        this.isLoading = true;
        const isFileAnImage = file.includes('.jpg') || file.includes('.png');

        if (isFileAnImage) {
          this.isPreviewImage = true;
          imagePreviewPane.src = file;
          this.isLoading = false;
        } else {
          this.pdfLink = file;
          this.pdfSrc = pdf.createLoadingTask(file);
          this.pdfSrc.promise.then(pdf => {
            this.numPages = pdf.numPages;
            this.isLoading = false;
          });
        }
      } else if (this.pdfSrc === null && !this.isPreviewImage) {
        this.pdfFileName = file.name
      } else {
        reader.onload = function (event) {
          if (fileImagePreviewCondition) {
            imagePreviewPane.src = event.target.result;
          }
        }
        reader.readAsDataURL(file);
      }
    },
    viewPrescriptionExternal() {
      this.$router.absUrl(this.pdfLink || this.file[this.fileArrayIndex]);
    },
  },
  mounted() {
    this.previewFirstFile();
  },
  WatsonsSmallLogo,
  NSHeartLogo,
}